<div class="onboarding-greeting" translate
    [translateParams]="{ name: greetingName }">
    ai-exam-onboarding.welcome-profile.greeting
</div>

<div class="onboarding-card-subtitle"
    [innerHTML]="'ai-exam-onboarding.welcome-profile.context' | translate:{language: languageName | titlecase}">
</div>

<div class="onboarding-divider"></div>

@if (showExtraFields) {
<div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
    <div class="onboarding-field">
        <div class="onboarding-field-label" translate>ai-exam-onboarding.first-name</div>
        <input class="onboarding-input" type="text" [formControl]="extraForm.controls.firstName">
    </div>
    <div class="onboarding-field">
        <div class="onboarding-field-label" translate>ai-exam-onboarding.last-name</div>
        <input class="onboarding-input" type="text" [formControl]="extraForm.controls.lastName">
    </div>
    <div class="onboarding-field">
        <div class="onboarding-field-label" translate>ai-exam-onboarding.email</div>
        <input class="onboarding-input" type="email" [formControl]="extraForm.controls.email">
    </div>
    <div class="onboarding-field">
        <div class="onboarding-field-label" translate>examination-ai.step1.mobile-phone</div>
        <input class="onboarding-input" type="tel" [formControl]="extraForm.controls.mobilePhone">
    </div>
    <div class="onboarding-field">
        <div class="onboarding-field-label" translate>ai-exam-onboarding.gender</div>
        <select class="onboarding-select" [formControl]="extraForm.controls.gender">
            <option value="" disabled translate>common.select</option>
            <option value="male" translate>gender.fuse.male</option>
            <option value="female" translate>gender.fuse.female</option>
        </select>
    </div>
</div>
}

<div class="onboarding-field">
    <div class="onboarding-field-label">
        <span translate>ai-exam-onboarding.personalization.native-language.question</span>
        <span class="text-red-500">*</span>
    </div>
    <mat-form-field class="onboarding-mat-field w-full" subscriptSizing="dynamic">
        <mat-select [value]="nativeLanguage || null" (selectionChange)="onNativeLanguageChange($event.value)"
            [placeholder]="'ai-exam-onboarding.personalization.native-language.placeholder' | translate">
            @for (option of nativeLanguageOptions; track option.value) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
</div>

<div class="onboarding-field">
    <div class="onboarding-field-label">
        <span translate>ai-exam-onboarding.birth-date</span>
    </div>
    <mat-form-field class="onboarding-mat-field w-full" subscriptSizing="dynamic">
        <input matInput class="cursor-pointer" [matDatepicker]="birthdatePicker"
            [formControl]="extraForm.controls.birthdate" [min]="minBirthdate" [max]="maxBirthdate" (click)="birthdatePicker.open()">
        <mat-datepicker-toggle matSuffix [for]="birthdatePicker"></mat-datepicker-toggle>
        <mat-datepicker #birthdatePicker startView="multi-year" [startAt]="birthdatePickerStartAt"></mat-datepicker>
    </mat-form-field>
</div>

@if (showLegalCheckbox) {
<div class="mt-4 mb-2">
    <mat-checkbox [formControl]="extraForm.controls.personalAccepted" color="primary">
        <span translate>examination-ai.step1.personal-declaration</span>
    </mat-checkbox>
</div>
}

<div class="onboarding-actions">
    <button type="button" class="onboarding-btn-primary flex-1" [disabled]="isContinueDisabled()"
        (click)="onContinue()">
        @if (!loading) {
        <span translate>ai-exam-onboarding.continue</span>
        } @else {
        <span class="inline-flex items-center justify-center gap-2">
            <mat-spinner [diameter]="18" [strokeWidth]="3"></mat-spinner>
            <span translate>ai-exam-onboarding.loading</span>
        </span>
        }
    </button>
</div>
